import React from "react";
import { Container, Row } from "reactstrap";
import LegalDocRequestForm from "../LegalDocRequestForm";
import AssetRequestForm from "../AssetRequestForm";
import HelpDeskRequestForm from "../HelpDeskRequestForm";
import Header from "../../../../Layout/Header/Header";
import { SOW_SCHEMA } from "../../../Forms/sow.schema";

interface FormWizardContainerProps {
  formType: "legalDocRequestForm" | "assetRequestForm" | "helpDeskRequestForm";
  filterStatus?: string;
  reportTitle?: string;
}

const FormWizardContainer: React.FC<FormWizardContainerProps> = ({
  formType,
}) => {
  const renderForm = () => {
    switch (formType) {
      case "legalDocRequestForm":
        return <LegalDocRequestForm schema={SOW_SCHEMA} />;

      case "assetRequestForm":
        return <AssetRequestForm />;

      case "helpDeskRequestForm":
        return <HelpDeskRequestForm />;
      default:
        return <div>Invalid form type specified.</div>;
    }
  };

  return (
    <Container fluid>
      <Header />
      <Row>{renderForm()}</Row>
    </Container>
  );
};

export default FormWizardContainer;
